module.exports = __webpack_public_path__ + "img/no.91858497.svg";